import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=0883b536&scoped=true"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"
import style0 from "./calendar.vue?vue&type=style&index=0&id=0883b536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883b536",
  null
  
)

export default component.exports